import Modals from "../../components/common/Modal";
import { useDispatch } from "react-redux";
import * as actionUrl from "../../store/actions";
import BidHistoryPage from "./bidHistoryPage";
function BidHistoryEAuctionReportModal({ open, setOpen, modalRight }) {
  const handleBidBookClose = () => {
    setOpen("");
  };
  const dispatch = useDispatch();

  return (
    <>
      <Modals
        title = "Bid History Report"
        show={open === "bidhistoryReportEnglish"}
        handleClose={() =>handleBidBookClose()}
        size="xl"
      >          
        <BidHistoryPage
        modalRight={
            open === "bidhistoryReportEnglish" ||
            (open === "editingAuctionCenterData" || modalRight?.length > 0
              ? modalRight
              : [])
          }
        />
      </Modals>   
    </>
  );
}

export default BidHistoryEAuctionReportModal;
